import { useEffect, useState } from 'react';
import { LordIcon } from '@src/components/lord-icon/lord-icon';
import styles from './Categories.module.scss';
import { 
  IconSkill,
  IconTier,
  IconExtension,
  IconMood,
 } from '@src/constants';
import IconVideo from 'src/assets/icons/cover-video.svg?react';
import IconAudio from 'src/assets/icons/cover-audio.svg?react';
import IconSlide from 'src/assets/icons/cover-slide.svg?react';

type Props = {
  categories?: string;
  lessonType?: string;
  isAussie?: boolean;
  isExtensionAvailable?: boolean;
  technology?: string;
};


function NewCategories(props: Props) {
  const [tiers, setTiers] = useState('')
  const [skill, setSkill] = useState('')
  const [mood, setMood] = useState('')
  const [containSlides, setContainSlides] = useState('')
  const [containVideo, setContainVideo] = useState('')
  const [containAudio, setContainAudio] = useState('')

  useEffect(() => {
    if (props.categories) {
      const categories = JSON.parse(props.categories)
      if (categories['Tiers']) {
        setTiers(categories['Tiers'])
      }
      if (categories['Skill']) {
        setSkill(categories['Skill'])
      }
      if (categories['Mood']) {
        setMood(categories['Mood'])
      }
      if (categories['ContainSlides']) {
        setContainSlides(categories['ContainSlides'])
      }
      if (categories['ContainVideo']) {
        setContainVideo(categories['ContainVideo'])
      }
      if (categories['ContainAudio']) {
        setContainAudio(categories['ContainAudio'])
      }
    }
  }, [props.categories])

  if (props.isAussie) {
    return (
      <div>
        {skill && (
        <div className={styles.tagWrapper}>
          <span className={styles.tagLabel}>Skill</span>
          <div className={[styles.tagBox, styles['skill']].join(' ')}>
            <LordIcon
              src={IconSkill}
              isHover={true} 
              colors={{
                primary: '#274649',
                secondary: '#FFB073'
              }}
              size={16}
              target='.Categories_tagBox__9\+qr7'
            />
            <span>{skill}</span>
          </div>
        </div>
      )}
      {mood && (
        <div className={styles.tagWrapper}>
          <span className={styles.tagLabel}>Mood</span>
          <div className={[styles.tagBox, styles['mood']].join(' ')}>
            <LordIcon
              src={IconMood}
              isHover={true} 
              colors={{
                primary: '#274649',
                secondary: '#FFB073'
              }}
              size={16}
              target='.Categories_tagBox__9\+qr7'
            />
            <span>{mood}</span>
          </div>
        </div>
      )}
      {props.isExtensionAvailable ? 
        <div className={styles.tagWrapper}>
          <span className={styles.tagLabel} style={{width: 92}}>Extension</span>
          <div className={[styles.tagBox, styles['extension']].join(' ')}>
            <LordIcon src={IconExtension}
              isHover={true} 
              colors={{
                primary: '#274649',
                secondary: '#FFB073'
              }}
              size={18}
              target='.CoverUnit_tagBox__nusN2' />
            <span>Extension</span>
          </div>
        </div> : null}
        {(containSlides === "0" || containVideo === "1" || containAudio === "2") ? 
        <div className={styles.tagWrapper}>
          <span className={styles.tagLabel} style={{width: 92}}>Technology</span>
          <div className={styles.techView}>
            {containSlides === "0" ? <div className={styles.techBox}>
              <IconSlide width={18} />
              <span>Slides</span>
              </div> : null}
            {containVideo === "1" && 
            <div className={styles.techBox}>
              <IconVideo width={18} />
              <span>Video</span>
            </div>}
            {containAudio === "2" && 
            <div className={styles.techBox}>
              <IconAudio width={18} />
              <span>Audio</span>
            </div>}
          </div>
        </div> : null}
      </div>
    )
  }

  return (
    <div>
      {tiers && (
        <div className={styles.tagWrapper}>
          <span className={styles.tagLabel}>Tier</span>
          <div className={[styles.tagBox, styles['tiers']].join(' ')}>
            <LordIcon
              src={IconTier}
              isHover={true} 
              colors={{
                primary: '#274649',
                secondary: '#FFB073'
              }}
              size={16}
              target='.Categories_tagBox__9\+qr7'
            />
            <span>{tiers}</span>
          </div>
        </div>
      )}
      {mood && (
        <div className={styles.tagWrapper}>
          <span className={styles.tagLabel}>Mood</span>
          <div className={[styles.tagBox, styles['mood']].join(' ')}>
            <LordIcon
              src={IconMood}
              isHover={true} 
              colors={{
                primary: '#274649',
                secondary: '#FFB073'
              }}
              size={16}
              target='.Categories_tagBox__9\+qr7'
            />
            <span>{mood}</span>
          </div>
        </div>
      )}
      {props.isExtensionAvailable ? 
        <div className={styles.tagWrapper}>
          <span className={styles.tagLabel} style={{width: 92}}>Extension</span>
          <div className={[styles.tagBox, styles['extension']].join(' ')}>
            <LordIcon src={IconExtension}
              isHover={true} 
              colors={{
                primary: '#274649',
                secondary: '#FFB073'
              }}
              size={18}
              target='.CoverUnit_tagBox__nusN2' />
            <span>Extension</span>
          </div>
        </div> : null}
        {(containSlides === "0" || containVideo === "1" || containAudio === "2") && <div className={styles.tagWrapper}>
          <span className={styles.tagLabel} style={{width: 92}}>Technology</span>
          <div className={styles.techView}>
            {containSlides === "0" ? <div className={styles.techBox}>
              <IconSlide width={18} />
              <span>Slides</span>
              </div> : null}
            {containVideo === "1" && 
            <div className={styles.techBox}>
              <IconVideo width={18} />
              <span>Video</span>
            </div>}
            {containAudio === "2" && 
            <div className={styles.techBox}>
              <IconAudio width={18} />
              <span>Audio</span>
            </div>}
          </div>
        </div>}
    </div>
  );
}

export default NewCategories;
